module.exports = "<div gw-loader=\"submissionLoadPromise\"></div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/quoteandbind/common/views/quote-entry.html
// module id = 1050
// module chunks = 0